import { render, staticRenderFns } from "./ProcessedDocs.vue?vue&type=template&id=48d5f27e"
import script from "./ProcessedDocs.vue?vue&type=script&lang=js"
export * from "./ProcessedDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d5f27e')) {
      api.createRecord('48d5f27e', component.options)
    } else {
      api.reload('48d5f27e', component.options)
    }
    module.hot.accept("./ProcessedDocs.vue?vue&type=template&id=48d5f27e", function () {
      api.rerender('48d5f27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/ProcessedDocs.vue"
export default component.exports